// extracted by mini-css-extract-plugin
export var container = "_5u-0";
export var error = "_5u-9";
export var label = "_5u-5";
export var light = "_5u-6";
export var md = "_5u-3";
export var sm = "_5u-2";
export var thin = "_5u-8";
export var thinBold = "_5u-7";
export var vertical = "_5u-4";
export var xs = "_5u-1";